import { ThemeProvider } from '@material-ui/styles';
import React, { Component } from 'react';
import { Modal, Box, Paper, createTheme } from '@mui/material';
import ContactFormTools from '../../components/ContactFormTools';
import { getJson } from '../../helpers/RequestsHelper';
import MuiCustomGrid from './MuiCustomGrid';
import AuthFlow from '../../components/AuthFlow';

const theme = createTheme({
    palette: {
        primary: {
            main: '#d01a62',
        },
    },
    typography: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: 16
    }
})

const columnLayout = [
    { field: 'symbol', headerName: 'Symbol', padding: 0, width: 110, sortable: false, hideSortIcons: true, renderCell: (params) => (
        <strong>
            <a target="new" href={"https://www.binance.us/en/trade/pro/" + params.value}>{params.value}</a>
        </strong>
    )},
    { field: 'boundsLow', headerName: 'Low Bound', width: 110, sortable: false, hideSortIcons: true },
    { field: 'boundsHigh', headerName: 'High Bound', width: 110, sortable: false, hideSortIcons: true },
    { field: 'boundsSpread', headerName: 'Bounds % Spread', width: 110, sortable: false, hideSortIcons: true},
    { field: 'currentPrice', headerName: 'Current Price', width: 110, sortable: false, hideSortIcons: true },
    { field: 'percentInBounds', headerName: 'Percent in Bounds', width: 110, sortable: false, hideSortIcons: true },
    { field: 'buyAverage', headerName: 'Buy', width: 110, sortable: false, hideSortIcons: true },
    { field: 'buyCount', headerName: 'Buy Count', width: 110, sortable: false, hideSortIcons: true, hide: true },
    { field: 'sellAverage', headerName: 'Sell', width: 110, sortable: false, hideSortIcons: true },
    { field: 'sellCount', headerName: 'Sell Count', width: 110, sortable: false, hideSortIcons: true, hide: true },
    { field: 'sellSpread', headerName: 'Buy/Sell % Spread', width: 110, sortable: false, hideSortIcons: true},
    { field: 'alternativeSellAverage', headerName: 'Lower Sell', width: 110, sortable: false, hideSortIcons: true },
    { field: 'alternativeSellCount', headerName: 'Lower Sell Count', width: 110, sortable: false, hideSortIcons: true, hide: true },
    { field: 'alternativeSellSpread', headerName: 'Lower Buy/Sell % Spread', width: 110, sortable: false, hideSortIcons: true},
]

class CryptoRangeTrackerTool extends Component {

    state = {
        signupModalOpen: false,
        displayHelp: false,
        columns: columnLayout,
        rows: []
    }

    constructor() {
        super()

        this.getGridData = this.getGridData.bind(this)
        this.openColumnMenu = this.openColumnMenu.bind(this)
        this.createAlert = this.createAlert.bind(this)
        this.redirectAuthenticated = this.redirectAuthenticated.bind(this)
        this.closeModal = this.closeModal.bind(this)
        
        this.getGridData()
        setTimeout(() => {
            this.getGridData()
        }, 1000 * 60 * 60);
    }

    static getDerivedStateFromError(error) {
        console.log(error)
    } 

    componentDidMount() {
        this.manageLocalId()
    }

    manageLocalId() {
        let localId = localStorage.getItem("localId");
        if (!localId) {
            const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
            localId = uint32.toString(16)
            localStorage.setItem("localId", localId);
        }
        this.setState({ localId })
    }

    async getGridData() {
        let url = process.env.REACT_APP_SERVER_BASE_URL + '/screener/getCommonPrices'
        let json = await getJson(url)
            .catch((e) => {console.log(e)})
        
        if(json && !json.error) {
            this.setState({rows: json, gridDataLoaded: true})
        }
    }
    
    openColumnMenu(event, column, highlightedGrid) {
        let element = event.currentTarget
        this.setState({columnMenuOpen: true, columnMenuRef: element, menuColumn: column, menuHighlightedGrid: highlightedGrid})
    }

    createAlert(column) {
        const cognitoUser = window.userPool.getCurrentUser()
        var field = column.field
        var gridTag = "priceRangeTracker"
        var gridName = "Price Range Tracker"

        var alertData = {gridTag, gridName, field}
        if (!cognitoUser) { 
            this.setState({signupModalOpen: true, alertData})
        } else {
            this.setState({signupModalOpen: false, alertData})
            this.redirectAuthenticated(gridTag, field)
        }
    }

    redirectAuthenticated(gridTag, field) {
        this.closeModal()

        let url = 
            window.location.origin +
            "/workflow/template/screener_detectleader_sendemail?onboarding=template&tested=true&block_0_params=%7B%22fields%22%3A%7B%22field%22%3A%22%7B%7B" 
            + gridTag + "." + field + 
            "%3AScreener%3A%24ref%7D%7D%22%7D%7D&block_1_params=%7B%22subject%22%3A%20%22%7B%7Bsymbol%3AScreener%3Atext%7D%7D%20is%20the%20new%20leader%22%7D"

        window.open(url, "_blank")
    }
    
    closeModal() {
        this.setState({signupModalOpen: false})
    }
    
    render() {
        return (
            <ThemeProvider theme={theme}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        width: '-webkit-fill-available'
                    }}
                    ref={el => { this.elTop = el; }} 
                >
                    <br />
                    {this.headerView()}
                    <Paper sx={{display: 'flex', flex: 1, flexDirection: 'column', height: '100%', padding: '8px'}} elevation={2}>
                    
                    {this.state.gridDataLoaded && this.state.selectionModel && this.state.selectionModel.length > 0? this.highlightedView() : null}
                    {this.state.gridDataLoaded? this.dataView() : null}

                    </Paper>
                    <br />
                    {this.state.displayHelp? this.helpView() : null}
                    <ContactFormTools />
                </Box>

                {this.state.signupModalOpen? this.modalView() : null}
            </ThemeProvider>
        )
    }
    
    modalView() {
        return (
            <AuthFlow
                modalopen={this.state.signupModalOpen} 
                props={{
                    title: "Let's set up my alert for..", 
                    subtitle: this.state.alertData? [this.state.alertData.gridName, this.state.alertData.field].join(" - ") : "",
                    data: this.state.alertData, 
                    quickSignup: true, 
                    modal: true, 
                    modalOpen: this.state.signupModalOpen, 
                    closeModal: this.closeModal, 
                    onAuthenticated: this.redirectAuthenticated
                }} 
            />
        ) 
    }
    
    headerView() {
        return (
            <div style={{display: 'flex', paddingLeft: '8px', flexDirection: window.screen.width < 992? 'column' : 'row'}}>
                <h2 style={{alignSelf: 'flex-start', flex: 1, width: '100%', fontSize: window.screen.width < 992? '1.5rem' : '2rem', paddingBottom: 0}}>
                    {"Crypto Range Tracker"}
                </h2>
            </div>
        )
    }

    helpView() {
        const style = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            overflow: 'auto',
            maxHeight: '600px',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
        }
        return (
            <ThemeProvider theme={theme}>
                <Modal
                    open={this.state.displayHelp}
                    onClose={this.toggleHelp}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                    <div style={{display: 'flex', flexDirection: 'column'}}  ref={el => { this.elHelp = el; }} >
                        {this.topicView("Refresh", [
                            "This screener refreshes every 1 min and shows an alanysis of a ticker containing data for the last 1 hr", 
                            "1 hr ticker updates every minute (as one value gets added, one gets removed from the beginning)",
                            "Results refresh automatically, while all sorting, filters, selections, hidden columns, etc.. will persist, unless the page is refreshed",
                            "Refresh can be paused displaying the time it was paused for manual data analysis purposes",
                            "(Premium feature: persist on account)"
                        ])}
                        {this.topicView("Volume", [
                            "Volume has all been calculated to USD matching the average current asset price"
                        ])}
                        {this.topicView("Grid Types", [
                            "Total Volume Grid: Based on the combined total value for buys and sells (50K in USD buys and 30K in USD sells = 80K total USD volume)",
                            "Net Volume Grid: Based on the combined net value for buys and sells (50K in USD buys and 30K in USD sells = 20K net USD volume)",
                            "Buy and Sell Volume Grid: Based on the total value for buys and sells respectively",
                            "Trade Grid: Based on the number of combined maker and taker sales on said asset"
                        ])}
                        {this.topicView("Symbol", [
                            "Clicking on the symbol will open the selected market on Binance.US in a new tab"
                        ])}
                        {this.topicView("Activity | Recent Activity", [
                            "Based on the value of the Standard Deviation degree, activity being the combined value over the last hour (min 60, max 180), and recent activity being the combined value over the last 3 minutes (min 1, max 9)"
                        ])}
                        {this.topicView("Sum, Mean, Variance, Standard Deviation (SD), Value", [
                            "Calculated for the ticker values over the past 1 hr, including the last value",
                            "Value is the last value for this grid (last 1 min)"
                        ])}
                        {this.topicView("Sum %, Mean %, Value %", [
                            "Percentage difference between caused between current value and previous value (the percent change betwen the sum 1 min ago vs the sum now, mean 1 min ago vs mean now, etc.)"
                        ])}
                        {this.topicView("SD % Mean", [
                            "The ratio between the standard deviation and mean price/volume/trades, accurate portrayal of movement for an asset"
                        ])}
                        {this.topicView("SD °", [
                            "1, 2, or 3 standard deviations away from the mean for the current value (always positive), 1 standard deviation away would mean that the data is currently moving within expected values (around the mean), 2 further away from the mean, 3 the furthest"
                        ])}
                        {this.topicView("Value Δ Mean", [
                            "The actual difference between the current value and the mean"
                        ])}
                    </div>
                    </Box>
                </Modal>
            </ThemeProvider>
        )
    }

    topicView(title, descriptionLines) {
        return (
            <div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
                <h4>{title}</h4>
                {descriptionLines.map((line, index) => {
                    return <span key={index + "_title"} style={{paddingLeft: '16px'}}>{line}</span>
                })}
                <br />
            </div>
        )
    }

    dataView() {
        return (
            <MuiCustomGrid 
                rows={this.state.rows}
                columns={this.state.columns}
                sortModel={[{field: "sellSpread", sort: "desc"}]}
                refreshing={true}
                timer={"1 hr"}
                createAlert={this.createAlert.bind(this)}
                selectable={false}
            />
        )
    }
}

export default CryptoRangeTrackerTool;